const angular = require('angular');
const app = angular.module('learn-directives');
var tuiImageEditorImport = require('../../imports/tui-image-editor');

/**
 * Defines the add Images component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('addEditImages', ['Application', '$timeout', 'S3Uploads', 'Upload', function (Application, $timeout, S3Uploads, Upload) {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        content: '=',
        contentType: '@',
        onChange: '&?'
      },
      template: require('../../../templates/directives/cms/add-edit-images.html'),
      controller: ['$scope', function ($scope) {
        var self = this;
        self.contentType = $scope.contentType;
        self.currentTab = 'standard';
        self.modifiedLink = '';
        self.modifiedBannerId = 'banner-modify';
        self.modifiedCoverId = 'cover-modify';
        self.brandColor = Application.colors.get().slice(0, 1);
        self.savingExisting = false;
        self.editorReady = false;
        self.flags = Application.features.flags();
        self.cardType = self.flags.explore_in_list_view ? 'list': 'card';
        self.isNewList = self.cardType === 'list';
        self.isDedicatedWorkshop = self.flags.dedicated_workshops;
        self.iconStyle = {
          transform: `rotate(${ self.cardType === 'list' && self.isNewList ? '90deg':'0deg'})`
        };

        const typesWithBannerImage = [
          'article',
          'event',
          'workshop',
          'presentation',
          'scorm',
          'imported_content',
          'track',
          'journey',
        ];

        self.hasBanner = typesWithBannerImage.includes(self.contentType);

        // black theme
        var blackTheme = {
          'common.bisize.width': '16px',
          'common.bisize.height': '16px',
          'common.backgroundImage': Application.tuiBgImage,
          'common.bi.image': Application.tuiBgImage,
          'common.backgroundColor': '#fff',
          'common.border': '1px solid #c1c1c1',
      
          // header
          'header.backgroundImage': 'none',
          'header.backgroundColor': 'transparent',
          'header.border': '0px',
      
          // load button
          'loadButton.backgroundColor': '#fff',
          'loadButton.border': '1px solid #ddd',
          'loadButton.color': '#222',
          'loadButton.fontFamily': '\'Inter\', Helvetica, Arial, sans-serif',
          'loadButton.fontSize': '12px',
      
          // download button
          'downloadButton.backgroundColor': '#fdba3b',
          'downloadButton.border': '1px solid #fdba3b',
          'downloadButton.color': '#fff',
          'downloadButton.fontFamily': '\'Gotham Rounded SSm A\', \'Gotham Rounded SSm B\', sans-serif',
          'downloadButton.fontSize': '12px',
      
          // main icons
          'menu.normalIcon.path': 'icon-d.svg',
          'menu.normalIcon.name': 'icon-d',
          'menu.activeIcon.path': 'icon-b.svg',
          'menu.activeIcon.name': 'icon-b',
          'menu.disabledIcon.path': 'icon-a.svg',
          'menu.disabledIcon.name': 'icon-a',
          'menu.hoverIcon.path': 'icon-c.svg',
          'menu.hoverIcon.name': 'icon-c',
          'menu.iconSize.width': '24px',
          'menu.iconSize.height': '24px',
      
          // submenu primary color
          'submenu.backgroundColor': 'transparent',
          'submenu.partition.color': '#e5e5e5',
      
          // submenu icons
          'submenu.normalIcon.path': 'icon-d.svg',
          'submenu.normalIcon.name': 'icon-d',
          'submenu.activeIcon.path': 'icon-b.svg',
          'submenu.activeIcon.name': 'icon-b',
          'submenu.iconSize.width': '32px',
          'submenu.iconSize.height': '32px',
      
          // submenu labels
          'submenu.normalLabel.color': '#858585',
          'submenu.normalLabel.fontWeight': 'normal',
          'submenu.activeLabel.color': '#000000',
          'submenu.activeLabel.fontWeight': 'normal',
      
          // checkbox style
          'checkbox.border': '1px solid #ccc',
          'checkbox.backgroundColor': '#fff',
      
          // rango style
          'range.pointer.color': self.brandColor,
          'range.bar.color': '#858585',
          'range.subbar.color': self.brandColor,
      
          'range.disabledPointer.color': '#d3d3d3',
          'range.disabledBar.color': 'rgba(85,85,85,0.06)',
          'range.disabledSubbar.color': 'rgba(51,51,51,0.2)',
      
          'range.value.color': '#858585',
          'range.value.fontWeight': 'normal',
          'range.value.fontSize': '11px',
          'range.value.border': '0',
          'range.value.backgroundColor': '#858585',
          'range.title.color': '#858585',
          'range.title.fontWeight': 'lighter',
      
          // colorpicker style
          'colorpicker.button.border': '0px',
          'colorpicker.title.color': '#858585'
        };

        

        self.initialize = function() {
          self.state = 'new';

          if (self.hasBanner) {
            // Cannot allow a scenario where one image exists, but not the other
            if ($scope.content.image || $scope.content.banner_image) {
              self.state = 'edit';
            } 
          }

          // Use as an opportunity to commonize image locations.
          // These conditions only apply to media.
          if ($scope.content.images && self.contentType !== 'scorm') {
            if ($scope.content.images.medium) {
              $scope.content.images.explore = $scope.content.images.medium;
              $scope.content.images.small = '';
              $scope.content.images.medium = '';
              $scope.content.images.large = '';
              self.state = 'edit';
            }
            if ($scope.content.images.custom) {
              $scope.content.images.explore = $scope.content.images.custom;
              $scope.content.images.custom = '';
              self.state = 'edit';
            }
          }
          // Set article/event/presentation/poll to edit state
          if ($scope.content.image || $scope.content.banner_image) {
            self.state = 'edit';
            return;
          }

          // Set video/file to edit state
          if ($scope.content.images) {
            if ($scope.content.images.explore) {
              self.state = 'edit';
            }
          }
        };

        self.justification = {
          set: function(type) {
            if (self.currentTab === 'featured') {
              $scope.content.featured_justification = type;
              if ($scope.onChange) {
                $scope.onChange({type: 'featured_justification'});
              }
              return;
            }
            $scope.content.cover_justification = type;
            if ($scope.onChange) {
              $scope.onChange({type: 'cover_justification'});
            }
          },
          showLeft: function() {
            if (!$scope.content) {
              return true;
            }
            if (self.currentTab === 'featured') {
              if (!$scope.content.featured_justification || $scope.content.featured_justification === 'left') {
                return true;
              }
              return false;
            }
            if (!$scope.content.cover_justification || $scope.content.cover_justification === 'left') {
              return true;
            }
          },
          showCenter: function() {
            if (!$scope.content) {
              return false;
            }
            if (self.currentTab === 'featured' && $scope.content.featured_justification === 'center') {
              return true;
            }
            if (self.currentTab === 'standard' && $scope.content.cover_justification === 'center') {
              return true;
            }
            return false;
          },
          showRight: function() {
            if (!$scope.content) {
              return false;
            }
            if (self.currentTab === 'featured' && $scope.content.featured_justification === 'right') {
              return true;
            }
            if (self.currentTab === 'standard' && $scope.content.cover_justification === 'right') {
              return true;
            }
            return false;
          }
        };

        self.setImage = function(image, type) {
          if (type === 'banner') {
            $scope.content.banner_image = image;
            if ($scope.onChange) {
              $scope.onChange({type: 'banner_image'});
            }
            if (self.state !== 'new') {
              // No need to continue if new state
              return;
            }
          }

          if (self.hasBanner && self.state === 'new') {
            $scope.content.banner_image = image;
          }

          if ((self.hasBanner && self.contentType !== 'track') || self.contentType === 'poll') {
            $scope.content.image = image;
            if ($scope.onChange) {
              $scope.onChange({type: 'image'});
            }
            // return even if new
            self.state = 'edit';
            return;
          }

          if (!$scope.content.images || typeof $scope.content.images !== 'object') {
            $scope.content.images = {};
          }

          $scope.content.images.explore = image;
          if ($scope.onChange) {
            $scope.onChange({type: 'content.images'});
          }
          self.state = 'edit';
        };

        self.makeProgress = function(percent) {
          return {
            'width': percent + '%'
          };
        };

        self.getBackground = function () {
          if (!$scope.content || !$scope.content.banner_image) {
            return;
          }

          return {
            'background-image': 'url(' + $scope.content.banner_image + ')'
          };
        }; 

        self.hideCover = function() {
          if (self.coverLoading || self.state === 'new' || !$scope.content) {
            return true;
          }
          if ((self.hasBanner && self.contentType !== 'track') || self.contentType === 'poll') {
            if (!$scope.content.image) {
              return true;
            }
            return false;
          }
          if (!$scope.content.images || !$scope.content.images.explore) {
            return true;
          }
          return false;
        };

        self.editInit = async function(imageUrl, type) {
          const tuiImageEditorModule = await tuiImageEditorImport.importModule();
          const ImageEditor = tuiImageEditorModule.default;
          self.editorReady = false;
          self.editType = type;

          self.editInstance = new ImageEditor(document.querySelector('#card-editor'), {
            usageStatistics: false,
            includeUI: {
              menu: ['filter', 'crop', 'flip', 'rotate'],
              theme: blackTheme,
              menuBarPosition: 'bottom'
            },
            cssMaxWidth: (document.documentElement.clientWidth - 200 ),
            cssMaxHeight: (document.documentElement.clientHeight - 200 ),
            selectionStyle: {
              borderColor: 'white',
              cornerColor: self.brandColor,
              cornerSize: 40,
              rotatingPointOffset: 100,
              transparentCorners: false
            }
          });

          self.editInstance.loadImageFromURL(`https://res.cloudinary.com/continu/image/fetch/${encodeURIComponent(imageUrl)}`, 'SampleImage').then(function() {
            self.editInstance.ui.activeMenuEvent();
            self.editorReady = true;
            $scope.$apply();
          }).catch(function(error) {
            console.log('load image error', error)
          })

          window.onresize = function() {
            if (self.editInstance && self.editInstance.ui) {
              self.editInstance.ui.resizeEditor();
            }
          };

          $timeout(function() {
            document.querySelector('.tui-image-editor-header').style.display = 'none';
          }, 5);
        };

        self.bannerReplace = function() {
          document.querySelector('#banner-upload').click();
        };
        self.coverReplace = function() {
          document.querySelector('#cover-upload').click();
        };

        self.editorSave = function() {
          self.savingExisting = true;
          function dataURItoBlob(dataURI) {
            var binary = atob(dataURI.split(',')[1]);
            var array = [];
            for(var i = 0; i < binary.length; i++) {
                array.push(binary.charCodeAt(i));
            }
            return new Blob([new Uint8Array(array)], {type: 'image/jpeg'});
          }

          var imgData = self.editInstance.toDataURL({format: 'jpeg'});

          try {
            var file = new File([dataURItoBlob(imgData)], 'uploaded-img.jpeg');
          } catch(e) {
            var blob = dataURItoBlob(imgData);
            blob.name = "uploaded-img.jpeg";
            blob.lastModifiedDate = new Date();
            var file = blob;
          }

          if (self.editType === 'banner') {
            self.bannerLoading = true;
            self.bannerPercent = 0;
          }
          if (self.editType === 'cover') {
            self.coverLoading = true;
            self.coverPercent = 0;
          }
          self.showEditor = false;
          S3Uploads.imagePolicy({fileName: file.name, contentType: file.type}, function(data) {
            var cloudFrontLink = data.CloudFrontLink;
            Upload.upload({
              url: 'https://' + data.Bucket + '.s3.amazonaws.com/',
              headers: {'Remove-auth': 'yes'},
              method: 'POST',
              data: {
                key: data.Key,
                'Content-Type': data.ContentType,
                AWSAccessKeyId: data.AWSAccessKeyId,
                'success_action_status': '201',
                policy: data.S3Policy,
                signature: data.S3Signature
              },
              file: file
            }).progress(function(evt) {
              var percent = parseInt(100.0 * evt.loaded / (evt.total * 0.05 + evt.total), 10);
              if (self.editType === 'banner') {
                self.bannerPercent = percent;
              }
              if (self.editType === 'cover') {
                self.coverPercent = percent;
              }
            }).success(function(data) {
              var link = cloudFrontLink;
              if (!link) {
                return;
              }
              self.setImage(link, self.editType);
              self.bannerLoading = false;
              self.coverLoading = false;
              self.editorCancel();
              Application.scrollTop();
              self.savingExisting = false;
            }).catch(function(error) {
              console.log('upload error', error);
            });
          }, function(error) {
            console.log('s3url error', error);
            Application.messaging.addMessage({type: 'error', text: error.message, duration: 5});
          });
        };

        self.editorCancel = function() {
          self.showEditor = false;
          self.editType = null;
          self.editInstance = null;
          if (!self.hasBanner || !$scope.content.images || !$scope.content.images.explore || !$scope.content.images.explore.length) {
            self.coverImage = '';
          }
        };

        self.removeImage = function(type) {
          if (type === 'banner') {
            $timeout(function() {
              $scope.content.banner_image = '';
              self.bannerImage = '';
              if ($scope.onChange) {
                $scope.onChange({type: 'banner_image'});
              }
              $scope.$apply();
            }, 0);
            return;
          }

          $timeout(function() {
            if ((self.hasBanner && self.contentType !== 'track') || self.contentType === 'poll') {
              $scope.content.image = '';
              if ($scope.onChange) {
                $scope.onChange({type: 'image'});
              }
            } else {
              if (!$scope.content.images) {
                $scope.content.image = {};
              }
              $scope.content.images.explore = '';
              if ($scope.onChange) {
                $scope.onChange({type: 'content.images'});
              }
            }
            self.coverImage = '';
            $scope.$apply();
          }, 0);
        }

        self.editImage = function(type) {
          // Set timeouts are required to trick the watch
          if (type === 'banner') {
            self.bannerImage = '';
            $timeout(function() {
              self.bannerImage = $scope.content.banner_image;
              $scope.$apply();
            }, 0);
            return;
          }

          self.coverImage = '';
          if ((self.hasBanner && self.contentType !== 'track')|| self.contentType === 'poll') {
            $timeout(function() {
              self.coverImage = $scope.content.image;
              $scope.$apply();
            }, 0);
            return;
          }

          $timeout(function() {
            self.coverImage = $scope.content.images.explore;
            $scope.$apply();
          }, 0);
        };

        // Watches the value passed to the banner Upload
        $scope.$watch('img.bannerImage', function(newVal, oldVal) {
          if (!newVal || newVal === oldVal) {
            return;
          }

          self.showEditor = true;
          $timeout(function() {
            self.editInit(newVal, 'banner');
          }, 5);
        });

        // Watches the value passed to the cover Upload
        $scope.$watch('img.coverImage', function(newVal, oldVal) {
          if (!newVal || newVal === oldVal) {
            return;
          }

          self.showEditor = true;
          $timeout(function() {
            self.editInit(newVal, 'cover');
          }, 5);
        });

        if ($scope.content) {
          self.initialize();
          if (Object.keys($scope.content) && Object.keys($scope.content).length) {
            return;
          }
        }

        var contentWatch = $scope.$watch('content', function(newVal, oldVal) {
          if (!newVal || newVal === oldVal) {
            return;
          }

          self.initialize();
          contentWatch();
        });
      }],
      controllerAs: 'img'
    };
  }]);
